<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5781 4.85005L13.1501 0.422086C12.8779 0.150825 12.5156 0 12.1309 0H5.86912C5.48437 0 5.12213 0.150825 4.84987 0.422086L0.421875 4.85005C0.149625 5.12244 0 5.48487 0 5.86981V12.1302C0 12.5151 0.149625 12.8776 0.421875 13.1499L4.84987 17.5779C5.12213 17.8492 5.48437 18 5.86912 18H12.1309C12.5156 18 12.8779 17.8492 13.1501 17.5779L17.5781 13.1499C17.8504 12.8776 18 12.5151 18 12.1302V5.86981C18 5.48487 17.8504 5.12244 17.5781 4.85005ZM15 11H3V7H15V11Z"
    />
  </svg>
</template>
